// Author Lin
// Date 2021-11-20 16:34:59

class MintalMesPrdSmeltingElectrodeParameter {
        constructor({
                id = null,
                productionDate = '',
                locationId = '',
                locationName = '',
                furnaceId = '',
                furnaceName = '',
                furnaceOrder = '',
                aPrimaryCurrent = '',
                aGear = '',
                aElectrodePosition = '',
                aWeight = '',
                aElectrodeCurrent = '',
                aResistance = '',
                aPressure = '',
                aBottomTemp = '',
                bPrimaryCurrent = '',
                bGear = '',
                bElectrodePosition = '',
                bWeight = '',
                bElectrodeCurrent = '',
                bResistance = '',
                bPressure = '',
                bBottomTemp = '',
                cPrimaryCurrent = '',
                cGear = '',
                cElectrodePosition = '',
                cWeight = '',
                cElectrodeCurrent = '',
                cResistance = '',
                cPressure = '',
                cBottomTemp = '',
                ambientTemp = '',
                remark = ''}
        = {}) {
            this.id = id;
            this.productionDate = productionDate;
            this.locationId = locationId;
            this.locationName = locationName;
            this.furnaceId = furnaceId;
            this.furnaceName = furnaceName;
            this.furnaceOrder = furnaceOrder;
            this.aPrimaryCurrent = aPrimaryCurrent;
            this.aGear = aGear;
            this.aElectrodePosition = aElectrodePosition;
            this.aWeight = aWeight;
            this.aElectrodeCurrent = aElectrodeCurrent;
            this.aResistance = aResistance;
            this.aPressure = aPressure;
            this.aBottomTemp = aBottomTemp;
            this.bPrimaryCurrent = bPrimaryCurrent;
            this.bGear = bGear;
            this.bElectrodePosition = bElectrodePosition;
            this.bWeight = bWeight;
            this.bElectrodeCurrent = bElectrodeCurrent;
            this.bResistance = bResistance;
            this.bPressure = bPressure;
            this.bBottomTemp = bBottomTemp;
            this.cPrimaryCurrent = cPrimaryCurrent;
            this.cGear = cGear;
            this.cElectrodePosition = cElectrodePosition;
            this.cWeight = cWeight;
            this.cElectrodeCurrent = cElectrodeCurrent;
            this.cResistance = cResistance;
            this.cPressure = cPressure;
            this.cBottomTemp = cBottomTemp;
            this.ambientTemp = ambientTemp;
            this.remark = remark;
        }
        }
        
        function newEntity() {
        return new MintalMesPrdSmeltingElectrodeParameter();
        }
        
            function gridFields() {
            return Object.freeze([
                {
                key: 'id',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeParameter.grid.id',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'productionDate',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeParameter.grid.productionDate',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'locationId',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeParameter.grid.locationId',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'locationName',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeParameter.grid.locationName',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'furnaceId',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeParameter.grid.furnaceId',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'furnaceName',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeParameter.grid.furnaceName',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'furnaceOrder',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeParameter.grid.furnaceOrder',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'aPrimaryCurrent',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeParameter.grid.aPrimaryCurrent',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'aGear',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeParameter.grid.aGear',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'aElectrodePosition',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeParameter.grid.aElectrodePosition',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'aWeight',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeParameter.grid.aWeight',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'aElectrodeCurrent',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeParameter.grid.aElectrodeCurrent',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'aResistance',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeParameter.grid.aResistance',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'aPressure',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeParameter.grid.aPressure',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'aBottomTemp',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeParameter.grid.aBottomTemp',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'bPrimaryCurrent',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeParameter.grid.bPrimaryCurrent',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'bGear',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeParameter.grid.bGear',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'bElectrodePosition',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeParameter.grid.bElectrodePosition',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'bWeight',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeParameter.grid.bWeight',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'bElectrodeCurrent',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeParameter.grid.bElectrodeCurrent',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'bResistance',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeParameter.grid.bResistance',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'bPressure',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeParameter.grid.bPressure',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'bBottomTemp',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeParameter.grid.bBottomTemp',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'cPrimaryCurrent',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeParameter.grid.cPrimaryCurrent',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'cGear',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeParameter.grid.cGear',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'cElectrodePosition',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeParameter.grid.cElectrodePosition',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'cWeight',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeParameter.grid.cWeight',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'cElectrodeCurrent',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeParameter.grid.cElectrodeCurrent',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'cResistance',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeParameter.grid.cResistance',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'cPressure',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeParameter.grid.cPressure',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'cBottomTemp',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeParameter.grid.cBottomTemp',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'ambientTemp',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeParameter.grid.ambientTemp',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'remark',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeParameter.grid.remark',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'textarea'
                }
                }
            ])}
        
        const filter = {
            idFilter : '',
            idListFilter : [],
            productionDateRteFilter : '',
            productionDateLteFilter : '',
            locationIdFilter : '',
            locationNameFilter : '',
            furnaceIdFilter : '',
            furnaceNameFilter : '',
            furnaceOrderFilter : '',
            aPrimaryCurrentFilter : '',
            aGearFilter : '',
            aElectrodePositionFilter : '',
            aWeightFilter : '',
            aElectrodeCurrentFilter : '',
            aResistanceFilter : '',
            aPressureFilter : '',
            aBottomTempFilter : '',
            bPrimaryCurrentFilter : '',
            bGearFilter : '',
            bElectrodePositionFilter : '',
            bWeightFilter : '',
            bElectrodeCurrentFilter : '',
            bResistanceFilter : '',
            bPressureFilter : '',
            bBottomTempFilter : '',
            cPrimaryCurrentFilter : '',
            cGearFilter : '',
            cElectrodePositionFilter : '',
            cWeightFilter : '',
            cElectrodeCurrentFilter : '',
            cResistanceFilter : '',
            cPressureFilter : '',
            cBottomTempFilter : '',
            ambientTempFilter : ''
        };
        
        const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));
        
        const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));
        
        const filterConfigs = [
                {
                key: 'productionDateRteFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeParameter.filter.productionDateRte',
                disabled: false,
                form: {
                type: 'datetimepicker'
                        }
                },
                {
                key: 'productionDateLteFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeParameter.filter.productionDateLte',
                disabled: false,
                form: {
                type: 'datetimepicker'
                        }
                },
                {
                key: 'locationNameFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeParameter.filter.locationName',
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'imfMstLocation'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"locationId":"id"}'
                        }
                },
                {
                key: 'furnaceNameFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeParameter.filter.furnaceName',
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'mintalMesMstFurnace'
                    ,correspondingField: 'furnaceName'
                    ,fieldsBindingByEntityModalSelected: '{"furnaceId":"id"}'
                        }
                },
                {
                key: 'furnaceOrderFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeParameter.filter.furnaceOrder',
                disabled: false,
                form: {
                type: 'input'
                        }
                },
        ];
        
        
            const entityFormConfigs = [
                {
                key: 'productionDate',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeParameter.entity.productionDate',
                sortable: true,
                disabled: false,
                form: {
                type: 'datetimepicker'
                        }
                },
                {
                key: 'locationName',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeParameter.entity.locationName',
                sortable: true,
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,required: true
                    ,entity: 'imfMstLocation'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"locationId":"id"}'
                        }
                },
                {
                key: 'furnaceName',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeParameter.entity.furnaceName',
                sortable: true,
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,required: true
                    ,entity: 'mintalMesMstFurnace'
                    ,correspondingField: 'furnaceName'
                    ,fieldsBindingByEntityModalSelected: '{"furnaceId":"id"}'
                        }
                },
                {
                key: 'furnaceOrder',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeParameter.entity.furnaceOrder',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'aPrimaryCurrent',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeParameter.entity.aPrimaryCurrent',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'aGear',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeParameter.entity.aGear',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'aElectrodePosition',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeParameter.entity.aElectrodePosition',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'aWeight',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeParameter.entity.aWeight',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'aElectrodeCurrent',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeParameter.entity.aElectrodeCurrent',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'aResistance',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeParameter.entity.aResistance',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'aPressure',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeParameter.entity.aPressure',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'aBottomTemp',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeParameter.entity.aBottomTemp',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'bPrimaryCurrent',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeParameter.entity.bPrimaryCurrent',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'bGear',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeParameter.entity.bGear',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'bElectrodePosition',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeParameter.entity.bElectrodePosition',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'bWeight',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeParameter.entity.bWeight',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'bElectrodeCurrent',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeParameter.entity.bElectrodeCurrent',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'bResistance',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeParameter.entity.bResistance',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'bPressure',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeParameter.entity.bPressure',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'bBottomTemp',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeParameter.entity.bBottomTemp',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'cPrimaryCurrent',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeParameter.entity.cPrimaryCurrent',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'cGear',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeParameter.entity.cGear',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'cElectrodePosition',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeParameter.entity.cElectrodePosition',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'cWeight',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeParameter.entity.cWeight',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'cElectrodeCurrent',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeParameter.entity.cElectrodeCurrent',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'cResistance',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeParameter.entity.cResistance',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'cPressure',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeParameter.entity.cPressure',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'cBottomTemp',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeParameter.entity.cBottomTemp',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'ambientTemp',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeParameter.entity.ambientTemp',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'remark',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeParameter.entity.remark',
                sortable: true,
                disabled: false,
                form: {
                type: 'textarea'
                        }
                }
        ]
        
        export {MintalMesPrdSmeltingElectrodeParameter, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
        , filterConfigs
        
        
        }
        